import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bot } from 'lucide-react';

const FloatingChatButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/ai-chat')}
      className="
        fixed 
        bottom-4 right-4 sm:bottom-6 sm:right-6
        w-12 h-12 sm:w-14 sm:h-14
        rounded-full
        bg-gradient-to-br from-light-secondary to-light-secondary/80
        dark:from-dark-secondary dark:to-dark-secondary/80
        text-light-on-secondary dark:text-dark-on-secondary
        shadow-lg hover:shadow-xl
        transition-all duration-300 ease-in-out
        hover:scale-110
        flex items-center justify-center
        z-50
        group
      "
      aria-label="Chat AI"
    >
      <Bot 
        size={24} 
        className="transition-transform duration-300 group-hover:rotate-12"
      />
    </button>
  );
};

export default FloatingChatButton;
